import { kebabCase } from "lodash";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Czym różni się Getaway od biur podróży?",
      acceptedAnswer: {
        "@type": "Answer",
        text: '<strong>Nie jesteśmy tradycyjnym biurem podróży, lecz Twoim osobistym asystentem i technologicznym kreatorem wyjazdów.</strong> Zamiast sprzedawać gotowe pakiety z zamkniętego katalogu, na Twoje zlecenie przeszukujemy cały rynek lotów, noclegów, transferów i usług lokalnych, aby stworzyć spersonalizowaną propozycję dopasowaną do Twojego budżetu i preferencji. Działamy na Twoje indywidualne zlecenie, jako Twój pełnomocnik: rezerwacje są dokonywane w Twoim imieniu, więc po zakupie to Ty jesteś właścicielem biletów i rezerwacji. <a href="https://www.getaway.pl/bezpieczenstwo-i-model-dzialania#porownanie">Sprawdź szczegółowe porównanie ></a>',
      },
    },
    {
      "@type": "Question",
      name: "Na czym polega kreator wyjazdów Getaway?",
      acceptedAnswer: {
        "@type": "Answer",
        text: '<strong>To nasza autorska technologia, która wykonuje pracę, która normalnie zajęłaby wiele godzin: przeszukuje cały rynek turystyczny, by stworzyć kompletną i spójną propozycję podróży.</strong> Wystarczy, że określisz swoje preferencje: kierunek, termin, budżet oraz inne wymagania. Nasz system łączy najlepsze dostępne loty, hotele i transfery w jedną całość. <a href="https://www.getaway.pl/creator">Wypróbuj kreator ></a>',
      },
    },
    {
      "@type": "Question",
      name: "Czy mogę wprowadzać zmiany w otrzymanej propozycji wyjazdu?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Tak, nasza propozycja jest interaktywna i możesz w niej dopasowywać opcje zgodnie ze swoimi preferencjami.</strong> W przeciwieństwie do sztywnych ofert biur podróży, w Getaway to Ty decydujesz o szczegółach. Możesz zmienić hotel, godziny lotów, dodać bagaż czy zmienić typ pokoju. Co ważne, każda zmiana jest natychmiast przeliczana przez system, więc od razu widzisz wpływ na cenę.",
      },
    },
    {
      "@type": "Question",
      name: "Czy oferujecie gotowe pakiety wyjazdowe?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Nie sprzedajemy pakietów znanych z katalogów biur podróży, ale dajemy możliwość skomponowania dowolnego wyjazdu oraz udostępniamy setki inspiracji.</strong> Tradycyjny pakiet wiąże się ze stałą datą i konkretnym hotelem. W Getaway możesz skorzystać z kreatora lub sprawdzić nasze inspiracje – elastyczne pomysły na wyjazdy przygotowane przez ekspertów.",
      },
    },
    {
      "@type": "Question",
      name: "Co to są inspiracje Getaway?",
      acceptedAnswer: {
        "@type": "Answer",
        text: '<strong>Inspiracje Getaway to zbiór autorskich pomysłów na podróże, przygotowanych przez nasz zespół ekspertów i pasjonatów.</strong> Stworzyliśmy je dla osób, które nie chcą planować od zera. Wybierając inspirację, trafiasz do kreatora wyjazdów, który zostaje automatycznie uzupełniony według naszego scenariusza. Otrzymujesz gotowy szkielet podróży, który możesz dowolnie rozbudować i modyfikować. <a href="https://www.getaway.pl/inspirations">Zobacz nasze Inspiracje ></a>',
      },
    },
    {
      "@type": "Question",
      name: "Czy przygotowanie propozycji wyjazdu jest płatne?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Nie, przygotowanie propozycji Twojego wyjazdu jest zawsze w 100% darmowe i do niczego Cię nie zobowiązuje.</strong> Możesz wypełnić nasz kreator, otrzymać kompletną propozycję, sprawdzić ceny i poprosić o poprawki – nie zapłacisz za to ani grosza. Wynagrodzenie pobieramy dopiero w momencie zakupu wyjazdu.",
      },
    },
    {
      "@type": "Question",
      name: "Ile kosztuje usługa Getaway?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Nasz model rozliczeń jest w pełni transparentny. Jedynym kosztem, jaki ponosisz na rzecz Getaway, jest prowizja doliczana do ceny wyjazdu w momencie zakupu.</strong> Wynosi ona odpowiednio: <b>4.1%</b> przy wyborze gotowej Inspiracji lub <b>4.8%</b> przy tworzeniu wyjazdu w Kreatorze. W zamian otrzymujesz spokój, wygodę, technologię i wsparcie 24/7. Co więcej, dzięki stawkom agencyjnym (B2B), często oferujemy ceny niższe niż rynkowe.",
      },
    },
    {
      "@type": "Question",
      name: "Kiedy muszę zapłacić za wyjazd?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Termin płatności zależy od rodzaju usług, które wybierzesz w swojej propozycji wyjazdu.</strong> Bilety lotnicze wymagają opłacenia 100% ceny w momencie rezerwacji (wymóg przewoźników). Inaczej wygląda sytuacja z hotelami – wiele obiektów pozwala na opłacenie pobytu w późniejszym terminie.",
      },
    },
    {
      "@type": "Question",
      name: "Czy muszę od razu płacić za cały wyjazd?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Nie, oferujemy elastyczne rozwiązania, dzięki którym nie musisz wpłacać pełnej kwoty w momencie zakupu wyjazdu.</strong> Choć nasz model różni się od klasycznej ‘zaliczki’ w biurze podróży, masz do wyboru dwie możliwości, aby podzielić płatność lub odłożyć ją w czasie: 1.Odroczona płatność za nocleg(i): jeśli w propozycji wybierzesz obiekt(y) z opcją bezpłatnego odwołania, w podsumowaniu możesz odznaczyć opcję ‘Zapłać całość teraz’. Wtedy w momencie zakupu opłacasz tylko pozostałe usługi, a za nocleg(i) zapłacisz w późniejszym terminie (zgodnie z warunkami danej rezerwacji), o czym Ci przypomnimy. 2. Raty i płatności odroczone Klarna nasz operator płatności (Stripe) współpracuje z systemem Klarna. Dzięki temu możesz sfinansować wyjazd w systemie ratalnym lub odroczyć płatność na zasadzie ‘Kup teraz, zapłać później’, zgodnie z limitami przyznanymi Ci przez ten serwis.",
      },
    },
    {
      "@type": "Question",
      name: "Czy otrzymam fakturę VAT za wyjazd?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Ze względu na nasz model działania (jako pełnomocnik), nie wystawiamy jednej zbiorczej faktury VAT za cały wyjazd.</strong> Otrzymasz komplet dokumentów: 1. <b>Fakturę VAT</b> od Getaway na kwotę naszej prowizji. 2. Fakturę/rachunek od przewoźnika za transport. 3. <b>Notę obciążeniową</b> za hotele (ponieważ korzystamy z hurtowych stawek bedbanków).",
      },
    },
    {
      "@type": "Question",
      name: "Czy moje pieniądze są bezpieczne?",
      acceptedAnswer: {
        "@type": "Answer",
        text: '<strong>Tak. Gwarancją bezpieczeństwa jest fakt, że wszystkie usługi rezerwujemy bezpośrednio na Twoje dane.</strong> W modelu Getaway działamy jako pełnomocnik – od momentu zakupu to Ty jesteś właścicielem biletów i rezerwacji. Są one całkowicie niezależne od funkcjonowania naszej firmy. Płatności procesuje bezpieczny system Stripe (używany m.in. przez Google czy Uber). <a href="https://www.getaway.pl/bezpieczenstwo-i-model-dzialania#bezpieczenstwo-srodkow">Dowiedz się więcej ></a>',
      },
    },
    {
      "@type": "Question",
      name: "Co się dzieje po tym, jak kupię wyjazd?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Od tego momentu przejmujemy stery – my zajmujemy się całą logistyką, a Ty możesz zacząć pakować walizki.</strong> Natychmiast po płatności otrzymujesz potwierdzenie (wiąże nas umowa), a my realizujemy rezerwacje. Proces ten zajmuje zazwyczaj <b>do 24 godzin</b>. Po finale otrzymasz dostęp do interaktywnego przewodnika.",
      },
    },
    {
      "@type": "Question",
      name: "Czym jest interaktywny przewodnik?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>To Twoje mobilne centrum dowodzenia podróżą w formie wygodnej aplikacji webowej.</strong> Otrzymasz unikalny link, który możesz przypiąć do ekranu smartfona. Przewodnik łączy dwie funkcje: pełną logistykę (bilety, vouchery w jednym miejscu) oraz inteligentny plan zwiedzania (trasa, bilety online, rekomendacje restauracji).",
      },
    },
    {
      "@type": "Question",
      name: "Czy mogę dokonać zmian w wyjeździe po dokonaniu zakupu?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Tak, po dokonaniu zakupu nadal możesz modyfikować i uzupełniać swój plan podróży przy naszym wsparciu.</strong> Zakres i koszty zależą od polityki usługodawców. Zgłoś nam potrzebę, a my przedstawimy wycenę i zaktualizujemy Twój przewodnik.",
      },
    },
    {
      "@type": "Question",
      name: "Czy muszę samodzielnie odprawiać się na loty?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>W zdecydowanej większości przypadków – nie. Dla Twojej wygody i spokoju, to nasz zespół zajmuje się tym za Ciebie.</strong> Karty pokładowe wgrywamy do przewodnika. Wyjątkiem są sytuacje techniczne lub wymogi linii (np. Ryanair), o czym Cię poinformujemy. Prosimy tylko o uzupełnienie danych z dowodu.",
      },
    },
    {
      "@type": "Question",
      name: "Czy podczas wyjazdu mam zapewnione ubezpieczenie?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Ubezpieczenie podróżne jest usługą opcjonalną, o której wyborze decydujesz samodzielnie w trakcie konfiguracji wyjazdu.</strong> Możesz je dodać jak każdą inną usługę. Jeśli to zrobisz, polisa i numery alarmowe trafią do Twojego przewodnika.",
      },
    },
    {
      "@type": "Question",
      name: "Z kim kontaktować się w razie problemów?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "<strong>Przed wyjazdem, przez cały czas trwania podróży, a także po jej zakończeniu, pozostajemy Twoim głównym punktem wsparcia.</strong> Działamy dwutorowo: 1. Interaktywny Przewodnik (dokumenty i kontakty). 2. Infolinia 24/7 (polskojęzyczne wsparcie w każdej sytuacji).",
      },
    },
  ],
};

export default {
  metaInfo() {
    return {
      title: "FAQ Getaway - najczęściej zadawane pytania i odpowiedzi",
      description:
        "Sprawdź FAQ Getaway i znajdź odpowiedzi na najczęściej zadawane pytania dotyczące naszych usług, kreatora, propozycji wyjazdu, interaktywnego przewodnika i opłat.",
      script: [
        {
          vmid: "ld-json-faq",
          type: "application/ld+json",
          innerHTML: JSON.stringify(faqSchema),
        },
      ],
      __dangerouslyDisableSanitizers: ["script"],
    };
  },
  data() {
    return {
      revealed: [],
      sectionsGuide: [
        {
          name: "Co się dzieje po tym, jak kupię wyjazd?",
          answer: `
          <p><strong>Od tego momentu przejmujemy stery - my zajmujemy się całą logistyką, a Ty możesz zacząć pakować walizki.</strong></p>
          <p>
          Natychmiast po dokonaniu płatności otrzymasz od nas potwierdzenie zakupu – od tego momentu wiąże nas umowa, a my przystępujemy do realizacji Twojego wyjazdu.
</p>
<p>
Nasz zespół zaczyna wykupywać bilety lotnicze, rezerwować hotele, transfery i inne usługi zgodnie z Twoim wyborem. Ponieważ dokonujemy rzeczywistych zakupów u zewnętrznych dostawców, proces kompletowania wszystkich rezerwacji zajmuje zazwyczaj do 24 godzin.
</p>
<p>
Gdy tylko wszystko zostanie sfinalizowane, otrzymasz od nas wiadomość e-mail i SMS z dostępem do Twojego osobistego interaktywnego przewodnika. To w nim znajdziesz wszystkie bilety, dokumenty i szczegóły wyjazdu. Od tej chwili aż do powrotu do domu jesteś pod naszą opieką.
</p>
          `,
        },
        {
          name: "Czym jest interaktywny przewodnik?",
          answer: `
            <p><strong>To Twoje mobilne centrum dowodzenia podróżą w formie wygodnej aplikacji webowej.</strong></p>
            <p>
            Otrzymasz od nas unikalny link, który możesz przypiąć jako ikonkę do ekranu głównego swojego smartfona. Dzięki temu dostęp do szczegółów podróży będzie zawsze pod ręką - dostępny jednym kliknięciem. Przewodnik łączy w sobie dwie kluczowe funkcje:
            <ul>
            <li>Pełna logistyka w jednym miejscu: tu znajdziesz wszystkie bilety, karty pokładowe, vouchery i potwierdzenia. Koniec z przeszukiwaniem e-maili. Dodaliśmy też praktyczny niezbędnik: podpowiemy Ci, jakie aplikacje warto ściągnąć na miejscu, jak działają karty miejskie czy płatności zbliżeniowe w lokalnej komunikacji.</li>
<li>
Inteligentny plan zwiedzania: to nie jest zwykła lista miejsc, ale przemyślana trasa ułożona w logiczną całość. Przy każdej atrakcji znajdziesz komplet informacji: godziny otwarcia, linki do zakupu biletów online (by ominąć kolejki) oraz ciekawostki. Zaproponujemy też opcje najciekawszych wycieczek. Całość uzupełniliśmy o nasze autorskie rekomendacje restauracji, barów i kawiarni w Twojej destynacji.
</li>
</ul>
</p>
          `,
        },
        {
          name: "Czy mogę dokonać zmian w wyjeździe po dokonaniu zakupu?",
          answer: `
          <p><strong>Tak, po dokonaniu zakupu nadal możesz modyfikować i uzupełniać swój plan podróży przy naszym wsparciu.</strong></p>
          <p>
          Zakres możliwych zmian oraz ewentualne koszty zależą od polityki konkretnych usługodawców. Niektóre usługi można zmieniać bezpłatnie niemal do samego wyjazdu (np. elastyczne rezerwacje hotelowe, transfery), inne mogą wiązać się z dopłatami wymaganymi przez przewoźnika (np. zmiana daty lotu czy dokupienie bagażu).
</p>
<p>
Niezależnie od tego, czy chcesz zamienić dojazd komunikacją miejską na prywatny transfer, dokupić bagaż, czy zarezerwować bilety na dodatkową atrakcję - jesteśmy do Twojej dyspozycji. Wystarczy, że zgłosisz nam taką potrzebę. Sprawdzimy możliwości, przedstawimy wycenę i prześlemy Ci link do płatności, a po wszystkim zaktualizujemy Twój interaktywny przewodnik.
</p>
          `,
        },
        {
          name: "Czy muszę samodzielnie odprawiać się na loty?",
          answer: `
<p><strong>W zdecydowanej większości przypadków - nie. Dla Twojej wygody i spokoju, to nasz zespół zajmuje się tym za Ciebie.</strong></p>
<p>Standardowo to my pilnujemy terminów i gdy tylko linia lotnicza otworzy taką możliwość, dokonujemy odprawy w Twoim imieniu. Gotowe karty pokładowe automatycznie wgrywamy do Twojego interaktywnego przewodnika. Nie musisz ich drukować ani szukać w mailach - wystarczy otworzyć link w smartfonie.</p>
<p>Zdarzają się jednak wyjątki niezależne od nas (np. specyficzne wymogi wizowe, kwestie techniczne przewoźnika / lotniska lub wymóg posiadania aplikacji danej linii). Jeśli odprawa online nie będzie możliwa lub przewoźnik będzie wymagał Twojego działania, niezwłocznie Cię o tym poinformujemy i przekażemy dokładną instrukcję, co należy zrobić.</p>
     <p>Jedyne, o co Cię poprosimy, to uzupełnienie danych dokumentów tożsamości przy zakupie wyjazdu - resztą zajmiemy się my.</p>

          `,
        },
        {
          name: "Czy podczas wyjazdu mam zapewnione ubezpieczenie?",
          answer: `
          <p><strong>Ubezpieczenie podróżne jest usługą opcjonalną, o której wyborze decydujesz samodzielnie w trakcie konfiguracji wyjazdu.</strong></p>
          <p>W otrzymanej propozycji wyjazdu znajdziesz sekcję dedykowaną ubezpieczeniu - traktujemy je jako dodatkową usługę, którą możesz, ale nie musisz dodać do swojego wyjazdu. Umożliwiamy wygodne porównanie dostępnych pakietów i sprawdzenie zakresu ochrony, aby decyzja była w pełni dopasowana do Twoich potrzeb.</p>
          <p>Zawsze rekomendujemy wykupienie polisy, aby zapewnić sobie bezpieczeństwo w razie nieprzewidzianych zdarzeń. Jeśli dodasz ubezpieczenie do swojego wyjazdu, komplet dokumentów (polisa, zakres ochrony oraz numer infolinii alarmowej ubezpieczyciela) trafi bezpośrednio do Twojego interaktywnego przewodnika. Dzięki temu w razie potrzeby wszystkie kluczowe informacje będą dostępne w smartfonie jednym kliknięciem.</p>

          `,
        },
        {
          name: "Z kim kontaktować się w razie problemów?",
          answer: `
          <p>
          <strong>Przed wyjazdem, przez cały czas trwania podróży, a także po jej zakończeniu, pozostajemy Twoim głównym punktem wsparcia.</strong>
</p>
<p>
Wychodzimy z założenia, że w sytuacjach stresowych najważniejsza jest przejrzystość i wiedza co robić. Dlatego nasz system pomocy działa dwutorowo:
<ul>
<li>Interaktywny Przewodnik: w Twoim interaktywnym przewodniku otrzymasz wszystkie kluczowe dokumenty i bezpośrednie kontakty do usługodawców, aby większość spraw można było załatwić od ręki u źródła.</li>
<li>Infolinia 24/7: na wyjazd otrzymasz od nas całodobowy, polskojęzyczny numer alarmowy. Niezależnie od tego, czy problem dotyczy hotelu, transferu, lotu czy innej sytuacji losowej - zadzwoń do nas, a my zajmiemy się resztą.</li>
</ul>
</p>
<p>
Nasza opieka nie kończy się w momencie powrotu do domu. Jeśli podczas wyjazdu wystąpiły zakłócenia, np. lot został znacznie opóźniony lub odwołany, również zajmiemy się formalnościami związanymi z uzyskaniem należnego odszkodowania w Twoim imieniu.
</p>
          `,
        },
      ],
      sectionsPayments: [
        {
          name: "Kiedy muszę zapłacić za wyjazd?",
          answer: `
            <p><strong>Termin płatności zależy od rodzaju usług, które wybierzesz w swojej propozycji wyjazdu.</strong></p>
            <p>
            Ponieważ Getaway nie operuje na gotowych pakietach, lecz kupuje usługi w czasie rzeczywistym bezpośrednio u dostawców, obowiązują nas ich zasady płatności. W praktyce oznacza to, że bilety lotnicze (szczególnie w taryfach bezzwrotnych i tanich liniach) wymagają opłacenia 100% ceny w momencie rezerwacji. Nie możemy ich ‘zablokować’ bez wpłaty, jak robią to biura podróży z lotami czarterowymi.
</p>
<p>
Inaczej wygląda sytuacja z hotelami i apartamentami. Tutaj zasady zależą od wybranej przez Ciebie stawki - wiele obiektów pozwala na opłacenie pobytu w późniejszym terminie, co daje Ci dużą elastyczność w zarządzaniu budżetem. Wystarczy, że wybierzesz stawkę z bezpłatnym odwołaniem rezerwacji, a przy płatności będziesz mieć możliwość opłacenia tej rezerwacji w późniejszym terminie.
</p>
          `,
        },
        {
          name: "Czy muszę od razu płacić za cały wyjazd?",
          answer: `
         <p><strong> Nie, oferujemy elastyczne rozwiązania, dzięki którym nie musisz wpłacać pełnej kwoty w momencie zakupu wyjazdu.</strong></p>
<p>
Choć nasz model różni się od klasycznej ‘zaliczki’ w biurze podróży, masz do wyboru dwie możliwości, aby podzielić płatność lub odłożyć ją w czasie:
<ul>
<li><strong>Odroczona płatność za nocleg(i)</strong>: jeśli w propozycji wybierzesz obiekt(y) z opcją bezpłatnego odwołania, w podsumowaniu możesz odznaczyć opcję ‘Zapłać całość teraz’. Wtedy w momencie zakupu opłacasz tylko pozostałe usługi, a za nocleg(i) zapłacisz w późniejszym terminie (zgodnie z warunkami danej rezerwacji), o czym Ci przypomnimy.</li>
<li><strong>Raty i płatności odroczone (Klarna)</strong>: nasz operator płatności (Stripe) współpracuje z systemem Klarna. Dzięki temu możesz sfinansować wyjazd w systemie ratalnym lub odroczyć płatność na zasadzie ‘Kup teraz, zapłać później’, zgodnie z limitami przyznanymi Ci przez ten serwis.</li>
</ul>
</p>
`,
        },
        {
          name: "Czy otrzymam fakturę VAT za wyjazd?",
          answer: `
          <p><strong>Ze względu na nasz model działania (jako pełnomocnik, a nie organizator turystyki), nie wystawiamy jednej zbiorczej faktury VAT za cały wyjazd.</strong></p>
          <p>
          Zamiast tego otrzymasz komplet dokumentów księgowych, który precyzyjnie odzwierciedla strukturę kosztów i podmiotów świadczących usługi:
          <ul>
          <li>Prowizja Getaway: na pełną kwotę naszej opłaty serwisowej otrzymasz od nas standardową fakturę VAT.</li>
          <li>Transport i inne usługi: rezerwacji lotów, wynajmu samochodu czy transferów dokonujemy w Twoim imieniu, wprowadzając dane Twojej firmy. Otrzymasz więc fakturę lub rachunek wystawiony bezpośrednio przez danego usługodawcę (zgodnie z jego indywidualną polityką wystawiania dokumentów).</li>
          <li>Noclegi: ponieważ korzystamy z hurtowych systemów rezerwacyjnych (tzw. bedbanków), dzięki którym uzyskujemy dla Ciebie niższe ceny, hotel nie wystawia faktury bezpośrednio na Ciebie. W tym przypadku wystawimy Ci notę obciążeniową na pełną kwotę noclegu. Jest to dokument księgowy potwierdzający poniesienie kosztu, który służy do rozliczenia wydatku w firmie, jednak nie jest to faktura VAT.</li>
</ul>
</p>
<p>
Ważne: Jeśli planujesz w pełni rozliczyć wyjazd w kosztach firmy, zalecamy upewnienie się w swojej księgowości, czy nota obciążeniowa będzie dla Was wystarczającym dokumentem.
</p>
          `,
        },
        {
          name: "Czy moje pieniądze są bezpieczne?",
          answer: `
          <p><strong>Tak. Gwarancją bezpieczeństwa jest fakt, że wszystkie usługi rezerwujemy bezpośrednio na Twoje dane.</strong></p>
          <p>
          W modelu Getaway działamy jako Twój pełnomocnik. Środki, które wpłacasz, są niezwłocznie przekazywane usługodawcom (liniom lotniczym, hotelom, operatorom transferów, wypożyczalniom samochodów, itp.). Oznacza to, że od momentu zakupu to Ty - a nie my - jesteś właścicielem biletów i rezerwacji.
</p>
<p>
Dzięki temu Twoje usługi są całkowicie niezależne od funkcjonowania naszej firmy. Masz 100% pewności, że bilety i noclegi są Twoją własnością i są opłacone bezpośrednio u dostawcy, co daje Ci gwarancję ich realizacji oraz wszystkie prawa przysługujące z tego tytułu.
</p>
<p>
Dodatkowo, samo procesowanie płatności powierzyliśmy światowemu liderowi - firmie Stripe (z której usług korzystają m.in. Uber, Spotify czy Google). Twoje dane płatnicze są w pełni szyfrowane i nigdy nie są przechowywane na naszych serwerach.

</p>
          `,
        },
      ],
      sectionsService: [
        {
          name: "Czym różni się Getaway od biur podróży?",
          answer: `
      <p><strong>Nie jesteśmy tradycyjnym biurem podróży, lecz Twoim osobistym asystentem i

technologicznym kreatorem wyjazdów.</strong></p>
      <p>Zamiast sprzedawać gotowe pakiety z zamkniętego katalogu, na Twoje zlecenie

przeszukujemy cały rynek lotów, noclegów, transferów i usług lokalnych, aby stworzyć

spersonalizowaną propozycję dopasowaną do Twojego budżetu i preferencji.</p>
      <p>Działamy na Twoje indywidualne zlecenie, jako Twój pełnomocnik: rezerwacje są

dokonywane w Twoim imieniu, więc po zakupie to Ty jesteś właścicielem biletów i

rezerwacji, a my dbamy o ich spójność i obsługę.</p>
    `,
        },
        {
          name: "Na czym polega kreator wyjazdów Getaway?",
          answer: `
            <p><strong>To nasza autorska technologia, która wykonuje pracę, która normalnie zajęłaby wiele godzin: przeszukuje cały rynek turystyczny, by stworzyć kompletną i spójną propozycję podróży.</strong></p>
            <p>Wystarczy, że określisz swoje preferencje: kierunek (dowolny!), termin, budżet czy liczbę osób.</p>
            <p>W efekcie otrzymujesz <strong>bezpłatnie</strong> interaktywną propozycję wyjazdu ‘szytą na miarę’. Możesz ją dowolnie modyfikować (np. zmienić hotel czy dodać bagaż), a gdy propozycja Ci się spodoba - kupić ją jednym kliknięciem i tym samym zlecić nam realizację wyjazdu.</p>
            <p>Sprawdź nas! <a href="/creator" target="_blank">Wypróbuj kreator i zobacz propozycję swojego wyjazdu >></a></p>
          `,
        },
        {
          name: "Jakie informacje najlepiej podać w kreatorze wyjazdów?",
          answer: `
            <p><strong>Wybierz dokładnie takie opcje, na jakich Ci zależy - im bardziej precyzyjne szczegóły podasz, tym lepiej dopasujemy wyjazd do Twoich potrzeb.</strong></p>
<p>Nie musisz podawać szerokich zakresów (np. 7-14 nocy) ‘na wszelki wypadek’, jak to trzeba robić na stronach biur podróży. W Getaway to my dostosowujemy się do Ciebie, a nie odwrotnie. Jeśli wpiszesz szeroki zakres dat, system może przygotować propozycję wyjazdu najkorzystniejszą cenowo (np. na 8 nocy), która niekoniecznie musi być tą Twoją wymarzoną (jeśli np. chcesz wyjechać na 11-12 nocy).</p>
<p>Dlatego nie bój się konkretów. Jeśli chcesz lecieć na 3 noce - wybierz 3 noce. Jeśli interesuje Cię konkretny standard hotelu, wylot z ulubionego lotniska lub specyficzne udogodnienia - zaznacz to. Im dokładniejsza jest Twoja ‘lista życzeń’ w kreatorze, tym większa szansa, że od razu otrzymasz propozycję takiego wyjazdu, jaki Cię interesuje.
</p>
<p><a href="/creator" target="_blank">Otwórz kreator i skomponuj wyjazd dokładnie według swoich potrzeb >></a></p>
`,
        },
        {
          name: "Czy mogę wprowadzać zmiany w otrzymanej propozycji wyjazdu?",
          answer: `
            <p><strong>Tak, nasza propozycja jest interaktywna i możesz w niej dopasowywać opcje zgodnie ze swoimi preferencjami.</strong></p>
            <p>W przeciwieństwie do sztywnych ofert biur podróży, w Getaway to Ty decydujesz o szczegółach. W propozycji możesz zmienić hotel na inny, wybrać dogodniejsze godziny lotów, dodać bagaż, zmienić typ pokoju czy rodzaj transportu. Masz wpływ na każdy element wyjazdu - od daty podróży, przez liczbę osób, aż po zmianę kierunku. W końcu to Twój wyjazd!</p>
            <p>Co ważne, każda zmiana jest natychmiast przeliczana przez system, więc od razu widzisz, jak Twoje decyzje wpływają na ostateczną cenę. Dopiero gdy propozycja w 100% Ci odpowiada, przechodzisz do płatności.</p>
          `,
        },
        {
          name: "Czy oferujecie gotowe pakiety wyjazdowe?",
          answer: `
            <p><strong>Nie sprzedajemy pakietów znanych z katalogów biur podróży, ale dajemy możliwość skomponowania dowolnego wyjazdu oraz udostępniamy setki inspiracji, które możesz dostosować do swoich potrzeb.</strong></p>
            <p>
            Tradycyjny pakiet wiąże się ze stałą datą, określoną liczbą nocy i konkretnym hotelem, którego nie można zmienić. W Getaway działamy inaczej. Możesz albo skorzystać z kreatora wyjazdów i skomponować własną, dowolną podróż, albo sprawdzić nasze inspiracje - to pomysły na wyjazdy przygotowane przez ekspertów, które służą jako doskonały punkt wyjściowy.
</p>
          `,
        },
        {
          name: "Co to są inspiracje Getaway?",
          answer: `
            <p><strong>Inspiracje Getaway to zbiór autorskich pomysłów na podróże, przygotowanych przez nasz zespół ekspertów i pasjonatów.</strong></p>
            <p>
            Stworzyliśmy je dla osób, które szukają pomysłu na wyjazd, ale nie chcą spędzać godzin na planowaniu od zera. Znajdziesz tu setki propozycji: od weekendowych city breaków, przez wakacje na plaży, aż po skomplikowane wyprawy objazdowe, ułożone w logiczną i atrakcyjną całość.
</p>
<p>
Co najważniejsze, Inspiracje nie są sztywnymi ofertami z katalogu. Wybierając jedną z nich, trafiasz do kreatora wyjazdów, który zostaje automatycznie uzupełniony według naszego scenariusza. Dzięki temu nie zaczynasz od czystej kartki - otrzymujesz gotowy szkielet podróży, który możesz dowolnie rozbudować i modyfikować zgodnie z własnymi potrzebami.
</p>
<p><a href="/inspirations" target="_blank">Zobacz nasze Inspiracje podróżnicze >></a></p>
          `,
        },
        {
          name: "Ile kosztuje usługa Getaway?",
          answer: `
          <p><strong>Nasz model rozliczeń jest w pełni transparentny. Jedynym kosztem, jaki ponosisz na rzecz Getaway, jest prowizja doliczana do ceny wyjazdu w momencie zakupu.</strong></p>
          <p>
          Nie narzucamy ukrytych marż na ceny biletów czy hoteli. Kwota, którą widzisz w propozycji, jest zawsze kwotą ostateczną i zawiera naszą opłatę serwisową, która wynosi odpowiednio:
            <ul>
            <li><strong>4.1%</strong> całkowitej kwoty podróży przy wyborze gotowej inspiracji.</li>
            <li><strong>4.8%</strong> całkowitej kwoty podróży przy tworzeniu wyjazdu w Kreatorze.</li>
</ul>
</p>
<p>
Co otrzymujesz w zamian? Przede wszystkim spokój, wygodę i technologię. Przejmujemy na siebie formalności, pilnujemy rezerwacji i dajemy Ci dostęp do interaktywnego przewodnika oraz wsparcia 24/7.
</p>
<p>
Co więcej, ta opłata często zwraca się z nawiązką. Dzięki dostępowi do stawek agencyjnych (B2B), niedostępnych dla indywidualnych użytkowników, często oferujemy ceny niższe niż rynkowe. W efekcie zyskujesz profesjonalną opiekę, płacąc za całość mniej, niż organizując to samodzielnie.
</p>
          `,
        },
      ],
    };
  },
  methods: {
    getSectionId(section) {
      return kebabCase(section.name.replace(/&/g, "-"));
    },
    getSectionHref(section) {
      return `#${this.getSectionId(section)}`;
    },
    onSectionClick(section) {
      if (this.revealed.includes(section.name)) {
        this.revealed = [...this.revealed.filter((i) => i !== section.name)];
      } else {
        this.revealed = [...this.revealed, section.name];
      }
    },
    handleHashParams() {
      if (!this.$route.hash) {
        return;
      }
      const section = [
        ...this.sectionsPayments,
        ...this.sectionsService,
        ...this.sectionsGuide,
      ].find(
        (i) =>
          this.getSectionId(i) === decodeURIComponent(this.$route.hash.slice(1))
      );
      if (!section) {
        return;
      }

      this.revealed.push(section.name);
    },
  },
  mounted() {
    this.handleHashParams();
  },
};
